import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { InfoMessageService } from '../services/info-message.service';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authService: AuthService, private messageService: InfoMessageService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.messageService.showMessage(
            "¡No autorizado!",
                error.error?.message ||
              'Se presentó un error al realizar esta acción, inténtalo de nuevo.',
            "fail"
          );
          // Swal.fire({
          //   icon: 'error',
          //   title: 'No autorizado',
          //   text: 'Tu sesión ha expirado o tu token es inválido.',
          //   buttonsStyling: false,
          // }).then(() => {
          //   //this.authService.logout();
          //   //this.router.navigate(['/login']);
          // });
        } else if (error.status === 404) {
          this.messageService.showMessage(
            "¡Ups!",
                error.error?.message ||
              'Se presentó un error al realizar esta acción, inténtalo de nuevo.',
            "fail"
          );
          // Swal.fire({
          //   icon: 'error',
          //   title: 'Error',
          //   text:
          //     error?.error?.message ||
          //     'Se presentó un error al realizar esta acción, inténtalo de nuevo',
          // }).then(() => {
          //   //this.authService.logout();
          //   //this.router.navigate(['/login']);
          // });
        } else {
          this.messageService.showMessage(
            "¡Ups!",
                error.error?.message ||
              'Se presentó un error al realizar esta acción, inténtalo de nuevo.',
            "fail"
          );
          // Swal.fire({
          //   icon: 'error',
          //   title: 'Error',
          //   text:
          //     error.error?.message ||
          //     'Se presentó un error al realizar esta acción, inténtalo de nuevo',
          // });
        }

        return throwError(() => error);
      })
    );
  }
}